import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/authentication/auth.service';
import { Usuario } from 'src/app/authentication/interfaces/interfaces';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';

@Component({
    selector: 'app-corporaales-doctor',
    templateUrl: './corporaales-doctor.component.html',
    styleUrls: ['./corporaales-doctor.component.scss'],
    standalone: false
})
export class CorporaalesDoctorComponent implements OnInit {

  title = 'datatables';
  dtOptions: DataTables.Settings = {};
  // dtOptionsSN: DataTables.Settings = {};
  
  private _usuario!: Usuario;
  public idSucursal!: string;
  public nombreSucursal: string = "";
  public perfil: string = '';
  public myTable: boolean = false;
  ordenes: any = [];
  public spinnerBoolean: boolean = false;
  public estadoFiltro: string = 'pendiente';
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  fecha = new Date();
  dia = String(this.fecha.getDate()).padStart(2, '0');
  mes = String(this.fecha.getMonth() + 1).padStart(2, '0');
  anio = this.fecha.getFullYear();
  hora = String(this.fecha.getHours()).padStart(2, '0');
  minuto = String(this.fecha.getMinutes()).padStart(2, '0');

  public fechaInicio = '';
  public fechaFin = '';
  public pagina;
  public busqueda;
  public limite;


  constructor(private ordenesService: OrdenesService,
    private authService: AuthService,
    private toastr: ToastrService,
    public router: Router) {

    this._usuario = authService.loginUsuario;
  }


  ngOnInit(): void {
    this.idSucursal = this._usuario.sucursal!;
    this.nombreSucursal = this._usuario.nombreSucursal!;
    this.perfil = this._usuario.perfil!;

    // if (this._usuario.perfil != "ecografo" && this._usuario.perfil != "Administrador" ) {
    //   this.router.navigate(['sistema/inicio']);
    // }

    console.log( this.idSucursal);
  //  setTimeout( () => {
    this.datatableEcografias();
    // }, 4000);

  }


  datatableEcografias(){

    this.spinnerBoolean = true;
    let lastPage = 0;
    let lastSearchText = "";
    this.dtOptions = {
      language: LanguageApp.spanish_datatables,
      pagingType: 'full_numbers',
      pageLength: 10,
      displayStart: lastPage, // Last Selected Page
      search: { search: lastSearchText }, // Last Searched Text
      serverSide: true,
      // processing: true,
      responsive: true,
      ajax: (dataTablesParameters: any, callback) => {

        this.pagina = dataTablesParameters.start;
        this.busqueda = dataTablesParameters.search.value;
        this.limite = dataTablesParameters.length;

        this.ordenesService.dtCorporalesDoctores(
          this.estadoFiltro,
          this.idSucursal,
          this.fechaInicio,
          this.fechaFin,
          this.pagina,
          this.busqueda,
          this.limite
        ).subscribe(resp => {

          this.ordenes = resp.data;
          this.spinnerBoolean = false;
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: []
          });
        })



      }
    };
  }

  peticionDeDatos() {
    this.spinnerBoolean = true;
    this.ordenesService.dtTomografias(
      this.estadoFiltro,
      this.idSucursal,
      this.fechaInicio,
      this.fechaFin,
      this.pagina,
      this.busqueda,
      this.limite
    ).subscribe(resp => {
      this.ordenes = resp.data;
      this.spinnerBoolean = false;
    })
  }


  filtrarEcografiasFechas(){
    this.reload();
  }
  reload() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload();
    });
  }
  
  /* -------------------------------------------------------------------------- */
  /*                               FACTURAR ORDEN                               */
  /* -------------------------------------------------------------------------- */
  subirImagenes(idOrden) {
    this.router.navigate(['/sistema/anadir-imagenes-corporales', this.makeid(100) + idOrden + this.makeid(100)]);
  }

  
  /* -------------------------------------------------------------------------- */
  /*                           GENERAR ALEATORIO ROUTE                          */
  /* -------------------------------------------------------------------------- */
  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJ12345679KLMNOPQRST08765454UVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}


export class LanguageApp {
  public static spanish_datatables = {
    processing: "Procesando...",
    search: "Buscar:",
    lengthMenu: "Mostrar _MENU_ registros",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Ant",
      next: "Sig",
      last: "Último"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    }
  }

}
